import { render, staticRenderFns } from "./OtherOverheadBreakdown.vue?vue&type=template&id=a0b4a124"
import script from "./OtherOverheadBreakdown.vue?vue&type=script&lang=js"
export * from "./OtherOverheadBreakdown.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports